import React, { useState, useEffect } from "react";
import NavLayout from "../../../layout/navLayout";
import Tabs from "../../../components/common/tabs";
import { useDispatch, useSelector } from "react-redux";
import { changeActiveTabs } from "../../../store/slices/orders/ordersSlice";
import Details from "./details";
import Product from "./product";
import { useLocation, useNavigate } from "react-router-dom";
import { readData } from "../../../service/order/orderService";
import { BackArrowIcon } from "../../../assets/images/svg/svg";
import { orders } from "../../../utils/router/constant";
import Documents from "./documents";
import Transaction from "./transaction";
import { getParamsFromURL } from "../../../utils/helper";

const SelectedOrder = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.orders.selectedOrder.tab);
  const activeTab = useSelector(
    (state) => state.orders.selectedOrder.activeTabs
  );
  const location = useLocation();
  const navigate = useNavigate();

  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
    }
  }, [orderId]);

  useEffect(() => {
    return () => {
      dispatch(changeActiveTabs("details"));
    };
  }, [dispatch]);

  const handleBackClick = () => {
    navigate(orders);
  };

  return (
    <NavLayout>
      <div className="order--detail__view">
        <div className="order-header">
          <span className="back-arrow" onClick={handleBackClick}>
            <BackArrowIcon />
          </span>
          <div className="order-title">{detailsData.code}</div>
        </div>
        <div className="main-content-wrapper-tab">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            changeActiveTab={(tab) => dispatch(changeActiveTabs(tab))}
          />
          <div className="selected-tab-bottom-content">
            {activeTab === "details" && <Details />}
            {activeTab === "product" && <Product code={orderId} />}
            {activeTab === "transaction" && <Transaction code={orderId} />}
            {activeTab === "documents" && <Documents />}
          </div>
        </div>
      </div>
    </NavLayout>
  );
};

export default SelectedOrder;
